import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { Link } from 'react-router-dom';

export default function BannerGroup(props) {
    return (
        <div className="container categories pt-6">
            <h2 className="title-lg text-center mb-4">Shop by Categories</h2>

            <div className="row">
                <div className="col-sm-6 col-lg-4">
                    <div className="banner banner-display banner-link-anim">
                        <Link to={`/shop?c=swimming`}>
                            <div className="lazy-overlay bg-2"></div>

                            <LazyLoadImage
                                src={`/assets/images/home/banners/banner-1.jpg`}
                                alt="Banner"
                                width={100}
                                height={540}
                                effect="blur"
                            />
                        </Link>

                        <div className="banner-content banner-content-center">
                            <h3 className="banner-title text-white"><Link to={`/shop?c=swimming`}>Swimming</Link></h3>
                            <Link to={`/shop?c=swimming`} className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4 order-lg-last">
                    <div className="banner banner-display banner-link-anim">
                        <Link to={`/shop?c=Gym`}>
                            <div className="lazy-overlay bg-2"></div>

                            <LazyLoadImage
                                src={`/assets/images/home/banners/banner-4.jpg`}
                                alt="Banner"
                                width={100}
                                height={540}
                                effect="blur"
                            />
                        </Link>

                        <div className="banner-content banner-content-center">
                            <h3 className="banner-title text-white"><Link to={`/shop?c=Gym`}>Gym</Link></h3>
                            <Link to={`/shop?c=Gym`} className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-lg-4 banners-sm">
                    <div className="row">
                        <div className="banner banner-display banner-link-anim col-lg-12 col-sm-6 col-xs-12">
                            <Link to={`/shop?c=SwimSuits`}>
                                <div className="lazy-overlay bg-2"></div>

                                <LazyLoadImage
                                    src={`/assets/images/home/banners/banner-2.jpg`}
                                    alt="Banner"
                                    width={100}
                                    height={260}
                                    effect="blur"
                                />
                            </Link>

                            <div className="banner-content banner-content-center">
                                <h3 className="banner-title text-white"><Link to={`/shop/?c=SwimSuits`}>SwimSuits</Link></h3>
                                <Link to={`/shop?c=SwimSuits`} className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right"></i></Link>
                            </div>
                        </div>

                        <div className="banner banner-display banner-link-anim col-lg-12 col-sm-6 col-xs-12">
                            <Link to={`/shop?c=Others`}>
                                <div className="lazy-overlay bg-2"></div>

                                <LazyLoadImage
                                    src={`./assets/images/home/banners/banner-3.jpg`}
                                    alt="Banner"
                                    width={100}
                                    height={260}
                                    effect="blur"
                                />
                            </Link>

                            <div className="banner-content banner-content-center">
                                <h3 className="banner-title text-white"><Link to={`/shop?c=Others`}>Others</Link></h3>
                                <Link to={`/shop?c=Others`} className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}